import { render, staticRenderFns } from "./AnnouncementBlock.vue?vue&type=template&id=1c6c4c89&scoped=true&lang=pug&"
import script from "./AnnouncementBlock.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBlock.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementBlock.vue?vue&type=style&index=0&id=1c6c4c89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6c4c89",
  null
  
)

export default component.exports